import React from 'react';
import Container from './style';
import CategoryProps from './type';

const CardCategory = ({
  onClick,
  title,
  icon,
  description,
  testId,
  tabIndex = 0
}: CategoryProps) => (
  <Container
    onClick={onClick}
    type="button"
    data-testid={testId}
    tabIndex={tabIndex}
  >
    <div>
      <img src={icon} alt="" />
      <h3>{title}</h3>
    </div>
    <p>{description}</p>
  </Container>
);

export default CardCategory;
